import logo from './images/metro_logo.png';
import paymentCard from './images/payment-card.png';
import timerBg from './images/timer-bg-image.png';
import videoBg from './images/video-img.png';
import CourseCompletedImage from './images/course-completed.png'

export default {
    logo,
    paymentCard,
    timerBg,
    videoBg,
    CourseCompletedImage
}